import React, {useEffect, useState} from 'react';

import useWebSocket, { ReadyState } from 'react-use-websocket';
import CircularSlider from '@fseehawer/react-circular-slider';
import { Slider, Container, Typography, Box, Chip, } from '@mui/material';
import logoUrl from "_assets/images/eutelsat-logo.svg";

const socketUrl = "wss://dev.api-webservices.eutelsat.fr:8881/api/webservices/eutelsat-websocket-demo/wsserver/matchfeed"


export default function Poc() {
  const [metrics, setMetrics] = useState();
  const [delay, setDelay] = useState(0);
  const [frequency, setFrequency] = useState(100);
  const [pingValue, setPingValue] = useState("");
  const [pingTime, setPingTime] = useState(0);
  const [responseDelay, setResponseDelay] = useState(0);
  const [waitingValue, setWaitingValue] = useState(false);
  const { sendMessage, lastMessage, readyState } = useWebSocket(socketUrl);

  useEffect(() => {
    if (lastMessage !== null) {
      try {
        const json = JSON.parse(lastMessage.data);

      if(!metrics) {
        setMetrics(json.simulation_data);
        setPingValue(json.simulation_data.user_input);
        sendFrequency();
      }else if(json.simulation_data.user_input !== metrics?.user_input) {
        setMetrics(json.simulation_data);
        setWaitingValue(false);
        setResponseDelay(Date.now() - pingTime);
      }
      } catch (error) {
        console.log("error", error);
      }
    }
  }, [lastMessage]);

  useEffect(() => {
    if(metrics) {
      sendValue();
    }
  }, [pingValue]);


const sendFrequency = () => sendMessage(frequency);

const updatePingValue = (value) => {
  setPingValue(value);
  // sendValue();
};

const connectionStatus = {
  [ReadyState.CONNECTING]: 'Connecting',
  [ReadyState.OPEN]: 'Open',
  [ReadyState.CLOSING]: 'Closing',
  [ReadyState.CLOSED]: 'Closed',
  [ReadyState.UNINSTANTIATED]: 'Uninstantiated',
}[readyState];

function sendValue() {
  console.log("send value: " , pingValue);
  setWaitingValue(true);
  setPingTime(Date.now());

  fetch('https://dev.api-webservices.eutelsat.fr/api/webservices/sng-demo/test', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({user_input: pingValue, sng_simulation_delay: delay})
  })
};
    return (
        <div>
            <Container sx={{textAlign: "left"}} maxWidth="xs">
              <Box sx={{mb:4, display: "flex", alignItems: 'center', flexDirection: "column"}}>
              <img width="50%" src={logoUrl} alt="Eutelsat logo" />
              <Typography variant="h3" sx={{fontWeight: "900"}}>Lineup</Typography>
              <Typography variant="body2" sx={{fontWeight: "bold", color: "primary.main"}}>Proof of concept</Typography>
              <Chip size="small" label={connectionStatus} color={connectionStatus === "Open" ? "success" : "error"} />
              
            <Box sx={{mb:2, mt: 5}}>
              <Typography>PTLU Frequency polling ({frequency}ms)</Typography>
              <Slider valueLabelDisplay="auto" marks min={100} max={10000} step={200} value={frequency} onChangeCommitted={sendFrequency} onChange={(event, newValue) => { setFrequency(newValue)}} aria-label="Default" />
            </Box>
            
            <h3>John Doe in his van</h3>
            
            <CircularSlider
              label="User input"
              dataIndex={pingValue}
              width={200}
              min={0}
              max={100}
              trackColor="#eeeeee"
              knobColor="#007dba"
              progressColorFrom="#007dba"
              onChange={updatePingValue}
            />
            <Box sx={{mb:2}}>
            <Typography>Skymon response delay ({delay}ms)</Typography>
            <Slider marks value={delay}  min={0} max={10000} step={200} onChange={(event, newValue) => { setDelay(newValue)}} aria-label="Default" valueLabelDisplay="auto" />
            </Box>
            
            <div>
            <h3>PWA Display
              
            </h3>
            <div>
            <Box sx={{mt:5, position: "relative"}}>
              <Box sx={{
                width: "50px",
                height: "50px", borderRadius: "50%", backgroundColor: "primary.main", position: "absolute", top: "-20px", left: "-20px", color: "white", fontSize: "10px", lineHeight: "50px", textAlign: "center"}}>
              {responseDelay}ms
              </Box>
              <CircularSlider
              min={0}
              max={100}
              label="Received value"
              progressColorFrom="#007dba"
              trackColor="#eeeeee"
              dataIndex={metrics?.user_input}
              width={200}
              hideKnob={true}
            />
            </Box>
            
            </div>
            
            </div>
            {waitingValue && <Chip size="small" sx={{mt: 1}} label="Waiting for value"></Chip>}
            </Box>
            </Container>
        </div>
    )
}
